@import "../../constants.scss";

.password-policy-wrapper {
  @include dropdown-bg;
  z-index: 10;
  overflow: visible;
  white-space: normal;
  word-wrap: break-word;
  font-size: var(--font-size-s);
  width: 246px;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
  border-radius: 5px;
  .password-policy-title {
    margin-bottom: 10px;
    font-size: var(--font-size-s);
    line-height: 16px;
    color: var(--text-color-main);
  }
  .password-rule-row {
    display: flex;
    align-items: center;
    color: var(--text-color-main);
    font-size: var(--font-size-s);
    line-height: 21px;
    margin-bottom: 5px;
    .seem-icon {
      font-size: var(--icon-size-xs);
    }
    &.valid {
      color: var(--low-alert-text-color);
    }
    .password-policy-text {
      margin-left: 5px;
    }
  }
}
.password-policy-popover {
  margin-top: -40px;
  box-shadow: var(--menu-box-shadow);
}
